import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-unexpected',
  templateUrl: './unexpected.component.html',
  styleUrls: ['./unexpected.component.scss']
})
export class UnexpectedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
